import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import i18n from '~/components/i18n'
import Layout from '~/components/Layout'
import { El } from '~/components/Layout/style'
import TableComponent from '~/components/TableComponent'
import { LIGHT_USER_ROLE_SLUG } from '~/Constants'
import { FarmersQuery } from '~/QueryHooks/Farmers'
import { useAuth } from '~/routes/components/AuthProvider'
import CreateEditNote from './CreateEditNote'

const getDefaultTableColumnHeaders = () => [
  {
    name: i18n.t('Time'),
    key: 'time',
    type: 'date',
    format: 'DD.MM.YYYY HH:mm'
  },
  {
    name: i18n.t('Contact'),
    key: 'contactName'
  },
  {
    name: i18n.t('Conversation content'),
    key: 'note',
    type: 'note-content'
  },
  {
    name: i18n.t('Created at'),
    key: 'createdAt',
    type: 'date',
    format: 'DD.MM.YYYY HH:mm'
  },
  {
    name: i18n.t('User'),
    type: 'note-creator',
    key: 'contactEmail'
  },
  {
    name: i18n.t('Actions')
  }
]

const getActions = () => [
  {
    popupMessage: i18n.t('Edit'),
    type: 'icon',
    name: 'pencil',
    size: 'large',
    actionType: 'edit',
    disableForRoleSlug: LIGHT_USER_ROLE_SLUG
  }
]

const Notes:React.FC = () => {
  const { t } = useTranslation()
  const { id } = useParams()
  const { systemData: { logged: { roleSlug } } } = useAuth()

  const lightUserLogged = roleSlug === LIGHT_USER_ROLE_SLUG

  const [dataFiltered, setDataFiltered] = useState({
    rows: 10,
    page: 0
  })
  const [noteId, setNoteId] = useState(null)
  const [tableColumnHeaders, setTableColumnHeaders] = useState(getDefaultTableColumnHeaders())

  const {
    data: notes,
    isLoading: isLoading,
    isFetching: isFetching,
    refetch: fetchNotes
  } = FarmersQuery.getFarmerNotes(id, dataFiltered)

  useEffect(() => {
    fetchNotes()
  }, [dataFiltered])

  function handleActionClick(row, type) {
    const { id } = row
    switch (type) {
      case 'edit':
        return setNoteId(id)
      default:
        return
    }
  }

  function renderNotes() {
    const actions = getActions()
    return <TableComponent
      tableColumnHeaders={tableColumnHeaders}
      dataFiltered={dataFiltered}
      isFetchingData={isFetching}
      animated
      rows={rows}
      actions={lightUserLogged ? actions.filter(action => !action.disableForRoleSlug) : actions}
      handleClickAction={(row, type) => handleActionClick(row, type)}
      total={filtered}
      handleChangeDataFiltered={(data, tableColumnHeaders) => {
        setTableColumnHeaders(tableColumnHeaders)
        setDataFiltered(data)
      }}
    />
  }

  function renderActions() {
    return <El.PageHeaderActionButton
      onClick={() => setNoteId('create')}
    >
      {t('Add new note')}
    </El.PageHeaderActionButton>
  }

  const { filtered, rows } = notes ? notes : { filtered: 0, rows: [] }

  return <Layout
    title={t('Communication')}
    useSpinner
    childContainerSize={'auto'}
    fontSizeHeader={'18px'}
    isBusy={isLoading}
    actions={renderActions()}
  >
    <CreateEditNote
      noteId={noteId}
      handleHiddenDrawer={(submited) => {
        if(submited) {
          fetchNotes()
        }
        setNoteId(null)
      }}
    />
    {renderNotes()}
  </Layout>
}
export default Notes